import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { setCurrentArticle, setPDFViewer } from "Actions";
import Goto from "../Goto";

import Slider from "react-slick";
import Sidebar from "../Sidebar";

import { EditorState, convertFromRaw, CompositeDecorator } from "draft-js";
import Editor, { composeDecorators } from "draft-js-plugins-editor";
import createLinkifyPlugin from "draft-js-linkify-plugin";
import createImagePlugin from "draft-js-image-plugin";
import createAlignmentPlugin from "draft-js-alignment-plugin";
import createResizeablePlugin from "draft-js-resizeable-plugin";

import { fetchArticle } from "Thunks";
import _ from "i18n";
import { TTP_API_URL, SOCIAL_NETWORKS_HOSTS } from "Config";

import {
  sortTags,
  getTagName,
  purifyString,
  //getDateLabel,
  //convertDateFromUTC,
  getUserNameForAvatar,
  getTo,
  attachmentIsPDF
} from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";

const linkifyPlugin = createLinkifyPlugin();
const resizeablePlugin = createResizeablePlugin();
const alignmentPlugin = createAlignmentPlugin();

const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator
);
const imagePlugin = createImagePlugin({ decorator });

const plugins = [linkifyPlugin, imagePlugin, alignmentPlugin, resizeablePlugin];

const linkDecorator = new CompositeDecorator([
  {
    strategy: (contentBlock, callback, contentState) => {
      contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        return (
          entityKey !== null &&
          contentState.getEntity(entityKey).getType() === "LINK"
        );
      }, callback);
    },
    component: props => {
      const { url } = props.contentState.getEntity(props.entityKey).getData();
      return (
        <a href={url} title={url}>
          {props.children}
        </a>
      );
    }
  }
]);

class Content extends PureComponent {
  state = {
    playVideo: false,
    editorState: EditorState.createEmpty()
  };
  componentDidMount() {
    const { fetchArticle, viewer } = this.props;
    fetchArticle(viewer.currentArticle.id);
    //this.controlSeekArticle();
  }

  componentWillReceiveProps(nextProps) {
    const { currentArticle } = this.props.viewer;
    const nextCurrentArticle = nextProps.viewer.currentArticle;
    if (currentArticle !== nextCurrentArticle) {
      let contentStateJSON = nextCurrentArticle.contentState;

      if (!contentStateJSON) {
        setTimeout(
          () => $(".article-file__content").prepend(nextCurrentArticle.content),
          0
        );
        return null;
      }

      const contentState = convertFromRaw(contentStateJSON);
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState });
    }
  }

  getArticleComponent() {
    const { currentArticle } = this.props.viewer;
    if (!currentArticle) {
      return null;
    }
  }

  renderContactSocialNetworkBlock(contactSocialNetworks, socialNetworkName) {
    if (!contactSocialNetworks) {
      return null;
    }

    let socialNetwork = contactSocialNetworks[socialNetworkName];

    if (socialNetwork) {
      let accessValue =
        socialNetworkName === "twitter"
          ? socialNetwork.username
          : socialNetwork.id;
      let snUrl =
        socialNetworkName === "linkedin"
          ? socialNetwork.publicProfileUrl
            ? socialNetwork.publicProfileUrl
            : ""
          : `${
              SOCIAL_NETWORKS_HOSTS[socialNetworkName.toUpperCase()]
            }/${accessValue}`;
      return (
        <a href={`${snUrl}`} target="_blank" className="profile__social-link">
          <i className={`icon icon-social-${socialNetworkName}`} />
        </a>
      );
    }

    return null;
  }

  renderAuthor(author) {
    const {
      firstName,
      lastName,
      avatar,
      descrption,
      signature,
      avatarUrl,
      //contactEmail,
      //contactSocialNetworks,
      enableAvatar
    } = author;

    if (!author || !enableAvatar) {
      return null;
    }

    const desc = descrption ? descrption : "";

    let avatarDiv = null;

    if (avatar) {
      avatarDiv = (
        <div
          className="author-avatar"
          style={{
            backgroundImage: `url(${
              avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
            })`
          }}
        />
      );
    } else {
      avatarDiv = (
        <div className="author-avatar empty-avatar">
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    }

    let signatureDiv = [];
    if (signature) {
      if (signature.title) {
        signatureDiv.push(<h3 key="h3">{signature.title}</h3>);
      }
      if (signature.head) {
        signatureDiv.push(<h4 key="h4">{signature.head}</h4>);
      }
    } else {
      signatureDiv.push(<h3 key="h3">{firstName + " " + lastName}</h3>);
    }

    return (
      <div className="author" key={author.id}>
        {avatarDiv}
        <div className="author-header">
          {signatureDiv}
          <p>{desc}</p>
        </div>
      </div>
    );
  }

  renderMedia() {
    let { playVideo } = this.state;

    const { main_media, albums } = this.props.viewer.currentArticle;

    if (
      albums &&
      albums.length > 0 &&
      albums[0].medias &&
      albums[0].medias.length > 0
    ) {
      return this.renderAlbum();
    }

    let style = {};
    let mediaClass = "article-file__img";
    let pictoDiv = null;
    let articleCoverUrl = "/img/article-cover-small.jpg";
    let isVideo = false;
    let isPDF = false;

    if (main_media) {
      if (main_media.preview && main_media.preview.webPath) {
        articleCoverUrl = main_media.preview.fullMediaUrl
          ? main_media.preview.fullMediaUrl
          : TTP_API_URL + "/" + main_media.preview.webPath;
        style.width = "100%";
        mediaClass += " " + main_media.docType.toLowerCase();

        isVideo = main_media.docType === "VIDEO";
        isPDF = ["PDF", "PPT"].indexOf(main_media.docType) !== -1;
        pictoDiv = (
          <span>
            <img src={`/img/${main_media.docType.toLowerCase()}.png`} alt="" />
          </span>
        );
      } else {
        if (main_media.fullCroppedWebPath) {
          articleCoverUrl = main_media.fullCroppedWebPath;
        } else {
          articleCoverUrl = main_media.fullMediaUrl
            ? main_media.fullMediaUrl
            : `${TTP_API_URL}/${main_media.webPath}`;
        }
      }
    }

    let bgImg = new Image();
    bgImg.src = articleCoverUrl + "?" + new Date().getTime();

    bgImg.onload = function(e) {
      if (bgImg.width >= 580) {
        $(".article-file__img img").css("width", "100%");
      }
    };

    if (playVideo) {
      return (
        <div className={mediaClass}>
          <video
            src={
              main_media.fullMediaUrl
                ? main_media.fullMediaUrl
                : `${TTP_API_URL}/${main_media.webPath}`
            }
            controls
            autoPlay
            style={{ height: "100%", width: "100%", objectFit: "cover" }}
            onEnded={() => {
              return this.setState({ playVideo: false });
            }}
          />
        </div>
      );
    }

    if (isVideo) {
      return (
        <div className={mediaClass}>
          <img src={articleCoverUrl} style={style} alt="" />
          <span
            onClick={() => {
              return this.setState({ playVideo: true });
            }}
          >
            <img src={`/img/video.png`} alt="" />
          </span>
        </div>
      );
    }
    if (isPDF) {
      return (
        <div className={mediaClass}>
          <img
            alt=""
            src={articleCoverUrl}
            style={style}
            onClick={this.displayPDF.bind(this, main_media)}
          />
          {pictoDiv}
        </div>
      );
    }
    return (
      <div className={mediaClass}>
        <img src={articleCoverUrl} alt="" />
        {pictoDiv}
      </div>
    );
  }

  renderAlbum() {
    const { albums } = this.props.viewer.currentArticle;
    const medias = albums[0].medias;

    let hide = medias.length === 1 ? "hide" : "";

    var settings = {
      dots: true,
      dotsClass: "slick-dots " + hide,
      infinite: false,
      arrows: false,
      speed: 500
    };

    return (
      <Slider {...settings}>
        {medias.map(media => {
          const path =
            media.preview &&
            (media.preview.fullMediaUrl || media.preview.webPath)
              ? media.preview.fullMediaUrl
                ? media.preview.fullMediaUrl
                : `${TTP_API_URL}/${media.preview.webPath}`
              : media.fullMediaUrl
                ? media.fullMediaUrl
                : `${TTP_API_URL}/${media.webPath}`;
          return (
            <div
              style={{
                background: `url(${path}) no-repeat center center`,
                backgroundSize: "contain",
                width: "100%",
                height: "500px"
              }}
            />
          );
        })}
      </Slider>
    );
  }

  renderArticleContent() {
    return (
      <Editor
        editorState={this.state.editorState}
        ref="editor"
        spellCheck={false}
        plugins={plugins}
        readOnly={true}
        onChange={editorState => {
          this.setState({ editorState });
        }}
        decorators={[linkDecorator]}
      />
    );
  }

  renderAttachments() {
    const { articles, fetched } = this.props;
    if (!fetched) {
      return null;
    }

    const article = articles[0];
    const { media_articles } = article;

    if (!media_articles || media_articles.length === 0) {
      return null;
    }

    const attachments = media_articles.filter(
      m => m.isAttachment && !m.isMain && !m.inHistory && !attachmentIsPDF(m)
    );
    const pdfs = media_articles.filter(
      m => m.isAttachment && !m.isMain && !m.inHistory && attachmentIsPDF(m)
    );

    const attachmentsJsx = attachments.map(a => {
      let iconClass = "icon icon-docs";
      switch (a.type) {
        case "IMAGE":
          iconClass = "icon icon-picture";
          break;
        case "VIDEO":
          iconClass = "icon icon-film";
          break;
        case "AUDIO":
          iconClass = "icon icon-earphones";
          break;
        case "FILE":
          iconClass = "icon icon-docs";
          break;
        default:
      }

      return (
        <li key={a.id}>
          <a
            href={
              a.fullMediaUrl ? a.fullMediaUrl : `${TTP_API_URL}/${a.webPath}`
            }
            target="_blank"
          >
            <span className={iconClass} />
            {a.name}
          </a>
        </li>
      );
    });

    const pdfsJsx = pdfs.map(a => {
      return (
        <li key={a.id}>
          <a
            href={
              a.fullMediaUrl ? a.fullMediaUrl : `${TTP_API_URL}/${a.webPath}`
            }
            target="_blank"
          >
            <span className="icon icon-docs" />
            {a.name}
          </a>
        </li>
      );
    });

    return (
      <div className="article-file__attachments">
        <ul>{attachmentsJsx}</ul>
        <ul className="pdfs-list">{pdfsJsx}</ul>
      </div>
    );
  }

  renderBlogArticle() {
    const { currentArticle } = this.props.viewer;
    const { auth } = this.props;
    const {
      title,
      tags,
      language,
      category,
      contentState,
      introduction,
      id,
      url,
      organization,
      isExternal,
      externalUrl
      //avatars
    } = currentArticle;

    const nameAttr = `name${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let tagsBlock = [];

    if (tags && tags.length > 0) {
      let sortedTags = sortTags(tags, language);
      tagsBlock = sortedTags.map(tag => {
        let tagName = tag[nameAttr];
        if (tagName == null || tagName.trim() === "") {
          tagName = getTagName(tag, nameAttr);
        }
        let tagElem = <span>{tagName}</span>;
        return <li key={`tag-${tag.id}`}>{tagElem}</li>;
      });
    }

    return (
      <div
        className={classnames(
          styles.media_container,
          "small-12 medium-8 article-content rmodal__left"
        )}
      >
        <Goto
          url={
            isExternal
              ? externalUrl
              : getTo({ id, url, organization, lng: language }, auth)
          }
        />

        {this.renderMedia()}
        <div className="article-file__category-content">
          <span
            className="article-file__category"
            style={{ backgroundColor: category.colorCode }}
          >
            {category[nameAttr]}
          </span>
        </div>
        <div
          className="article-file__organization"
          style={{ borderLeftColor: category.colorCode }}
        >
          {organization.abbreviation
            ? organization.abbreviation
            : organization.name}
        </div>
        <div className="article-file__title">
          <h1>{purifyString(title)}</h1>
        </div>

        <div className="article-file__content">
          {contentState ? this.renderArticleContent() : introduction}
          {isExternal ? (
            <a
              href={externalUrl}
              target="_blank"
              style={{
                fontWeight: 600,
                marginLeft: ".25rem",
                textDecoration: "underline"
              }}
            >
              {_("Read more")}
            </a>
          ) : null}
          {this.renderAttachments()}
        </div>
        <div className="article-file__tags">
          <h3>{_("Tags")}</h3>
          <ul>{tagsBlock}</ul>
        </div>
      </div>
    );
  }

  renderExternalArticle() {
    const { currentArticle } = this.props.viewer;

    const { externalUrl } = currentArticle;

    return (
      <div
        className={classnames(
          styles.media_container,
          "small-12 medium-8 article-content rmodal__left"
        )}
      >
        <Goto url={externalUrl} />

        <iframe id="external-url" title="External Article" src={externalUrl} />
      </div>
    );
  }

  displayPDF(media, e) {
    const { setPDFViewer } = this.props;

    setPDFViewer({
      isOpen: true,
      media
    });
    setTimeout(e => {
      document
        .getElementsByClassName("ReactModalPortal")
        .item(0).children[0].style.zIndex = 11;
    }, 50);
  }

  render() {
    const { currentArticle, articles } = this.props.viewer;

    if (!currentArticle || !articles) {
      return null;
    }

    //const { isExternal } = currentArticle;

    return (
      <Fragment>
        <div className="cell rmodal__body grid-x article-file">
          {/*isExternal ? this.renderExternalArticle() : */ this.renderBlogArticle()}
          <div className="cell small-12 medium-4 article-meta">
            <Sidebar currentResource={{ ...currentArticle }} type="ARTICLE" />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  viewer: state.articleViewer,
  auth: state.auth
});
const mapDispatchToProps = dispatch => ({
  setCurrentArticle: article => dispatch(setCurrentArticle(article)),
  fetchArticle: articleId => dispatch(fetchArticle(articleId)),
  setPDFViewer: data => dispatch(setPDFViewer(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);



// WEBPACK FOOTER //
// ./src/components/Reveal/ArticleViewer/Content.js